<template>
<el-dialog class='quotas-required-dialog' :title="overdate ? '套餐已过期' : '项目额度不足'" size='small' :visible.sync="dialogVisible" @close="close">
  <div v-if="organization">
    <p v-if="overdate">企业套餐已过期，请联系管理员续费或升级</p>
    <p v-else>企业套餐额度不足，请联系管理员续费或升级</p>
  </div>
  <div v-else>
    <p>您的永久项目额度不足，如果继续将会创建临时项目。临时项目会免费浏览8小时，之后会自动删除。
    </p>
    <br />
    <p>请购买额度或会员。</p>
    <!-- <p>
      1. 认证手机号；
      <span class='verified' v-if="user.cellphone">已认证</span>
      <a class='text-btn' href="/profile?verify=mobile&closeOnPQuota=true" target='_blank' v-else>去认证</a>
    </p> -->
    <!--
    <p>1. 购买账号额度。<span class='recommand'>推荐</span></p>
    <p>
      2. 认证公立学校教师，获得优惠；
      <span class='verified' v-if="user.occupation_verified">已认证</span>
      <a class='text-btn' href="/teacher?closeOnPQuota=true" target='_blank' v-else>去认证</a>
    </p>
    -->
  </div>

  <div class='buttons' slot='footer'>
    <div v-if="organization">
      <a class='el-button el-button--primary' @click="close">关闭</a>
    </div>
    <div v-else>
      <el-button type='text' @click="cancel()">继续创建</el-button>
      <a class='el-button el-button--primary' href="/price?closeOnPQuota=true" target='_blank'>购买额度</a>
    </div>
  </div>
</el-dialog>
</template>

<style lang="scss">
.quotas-required-dialog {
    p {
        line-height: 1.5;
        margin: 0.67em 0;
    }

    .recommand {
        color: $color-primary;
    }

    .verified {
        color: $font-color-light;
    }
}
</style>

<script>
import bus from '@/utils/bus'

export default {
  data() {
    return {
      dialogVisible: false,
      cancel: null
    }
  },
  computed: {
    overdate() {
      return this.$store.getters['quota/overdate']
    }
  },
  methods: {
    open(params) {
      let vm = this
      vm.dialogVisible = true
      if (params.cancel) { vm.cancel = params.cancel }

      bus.$on('GetPermanentsQuota', vm.onGetQuota)
    },
    close() {
      this.dialogVisible = false
      bus.$off('GetPermanentsQuota', this.onGetQuota)
    },
    onGetQuota(diff) {
      let _diff = diff === null ? '不限次数' : `${diff}次`
      this.$message(`已为您添加永久项目额度：${_diff}`)
      this.close()
      this.$parent.refreshData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// quotas_required.dialog.vue?4680d746